import { h } from 'preact';
import styles from './Skeleton.module.scss';
export function Skeleton({ width, height, borderRadius = '4px', className }) {
    const style = {
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
    };
    return h("div", { class: `${styles.skeleton} ${className || ''}`, style: style });
}
